/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_mode_switcher = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Mode switcher
		 */
		$('.js-mode-switcher-button').on('click', function () {

			/**
			 * Toggle the class on the body
			 */
			$('body').toggleClass('dark-mode');

			/**
			 * AJAX Post to save the mode in a cookie
			 */
			$.ajax({

				url: globalUrl + '/' + url[1] + '/a/a/theme-set',
				type: 'POST',
				data: {
					theme: $('body').hasClass('dark-mode') ? 'dark' : 'light'
				},
				headers: {
					'go-load': 1
				},
				success: function (data) {

					console.log(data);

				}

			});

		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_mode_switcher);